import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BackrsUserBadge } from '@backrs_ui/common-ui/src/atoms/BackrsUserBadge';
import { BadgeCircle } from '@backrs_ui/common-ui/src/atoms/BadgeCircle';
import { AppIcon, ICON_SIZES } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { Box, Typography, Skeleton } from '@mui/material';
import { BaseNugget } from '../BaseNugget';
import { HoverButton } from '../HoverButton';
import { TypeChip } from '../TypeChip';
var INFO_CONFIG = [
    {
        key: 'jobTitle',
        icon: _jsx(AppIcon, { iconName: "Briefcase01", diameter: ICON_SIZES['14px'], color: "Gray/600" }),
        maxLines: 1,
    },
    {
        key: 'employer',
        icon: _jsx(AppIcon, { iconName: "Building06", diameter: ICON_SIZES['14px'], color: "Gray/600" }),
        maxLines: 1,
    },
    {
        key: 'school',
        icon: _jsx(AppIcon, { iconName: "Bank", diameter: ICON_SIZES['14px'], color: "Gray/600" }),
        maxLines: 1,
    },
    {
        key: 'grade',
        icon: _jsx(AppIcon, { iconName: "Bank", diameter: ICON_SIZES['14px'], color: "Gray/600" }),
        maxLines: 1,
    },
    {
        key: 'similarities',
        icon: (_jsx(Box, { sx: { marginTop: function (_a) {
                    var backrs = _a.backrs;
                    return backrs.spacing['spacing-sm'];
                } }, children: _jsx(BadgeCircle, { size: "sm" }) })),
        maxLines: 3,
    },
];
export var NuggetProfile = function (_a) {
    var abbreviatedName = _a.abbreviatedName, jobTitle = _a.jobTitle, employer = _a.employer, school = _a.school, grade = _a.grade, similarities = _a.similarities, _b = _a.isLoadingSimilarities, isLoadingSimilarities = _b === void 0 ? false : _b, profileImageUrl = _a.profileImageUrl, role = _a.role, profileType = _a.profileType, onClick = _a.onClick, subText = _a.subText, _c = _a.fitContent, fitContent = _c === void 0 ? false : _c, actionParams = _a.actionParams, isHovered = _a.isHovered, isHighlighted = _a.isHighlighted, _d = _a.isLoadingSubText, isLoadingSubText = _d === void 0 ? false : _d;
    return (_jsx(BaseNugget, { subText: subText, onClick: onClick, fitContent: fitContent, isLoadingSubText: isLoadingSubText, isHighlighted: isHighlighted, children: _jsxs(Box, { sx: contentSx, children: [_jsxs(Box, { sx: headerContainerSx, children: [_jsx(HoverButton, { hasBookmarked: actionParams === null || actionParams === void 0 ? void 0 : actionParams.hasBookmarked, handleActionBookmark: actionParams === null || actionParams === void 0 ? void 0 : actionParams.handleActionBookmark, handleActionAddTask: actionParams === null || actionParams === void 0 ? void 0 : actionParams.handleActionAddTask, handleActionShare: actionParams === null || actionParams === void 0 ? void 0 : actionParams.handleActionShare, isVisible: (!!actionParams && isHovered) || false, isAbsolutelyPositioned: true, position: "flush" }), _jsxs(Box, { sx: profileImageAndNameContainerSx, children: [_jsxs(Box, { sx: profileImageWrapperStyle, children: [profileImageUrl ? (_jsx(Box, { component: "img", src: profileImageUrl, sx: profileImgSx })) : (_jsx(AppIcon, { iconName: "User02", diameter: "96px", color: "currentColor" })), role && _jsx(BackrsUserBadge, { variant: role })] }), _jsx(Typography, { variant: "text-lg-semibold", sx: abbreviatedNameStyle, children: abbreviatedName })] })] }), _jsxs(Box, { sx: smallProfileInfoChipContainerStyle, children: [_jsx(Box, { sx: smallProfileInfoContainerStyle, children: INFO_CONFIG.map(function (_a) {
                                var key = _a.key, icon = _a.icon, maxLines = _a.maxLines;
                                var props = { jobTitle: jobTitle, employer: employer, school: school, grade: grade, similarities: similarities };
                                var displayValue = props[key];
                                var isSimilaritiesLoading = key === 'similarities' && isLoadingSimilarities;
                                return displayValue || isSimilaritiesLoading ? (_jsxs(Box, { sx: infoRowStyle, children: [_jsx(Box, { sx: iconContainerSx, children: icon }), isSimilaritiesLoading ? (_jsx(Skeleton, { variant: "text", width: "80%", height: 20 })) : (_jsx(Typography, { variant: "text-sm-regular", color: function (_a) {
                                                var backrs = _a.backrs;
                                                return backrs.colors['Gray/600'];
                                            }, sx: profileAttributeTextSx(maxLines, key === 'similarities'), children: displayValue }))] }, key)) : null;
                            }) }), _jsx(Box, { sx: chipContainerSx, children: _jsx(TypeChip, { label: profileType === 'EXTERNAL' ? 'Real People' : 'Profile', icon: "User02" }) })] })] }) }));
};
var profileImgSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        position: 'relative',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        aspectRatio: '1 / 1',
        borderRadius: backrs.radius['radius-full'],
        border: "1px solid ".concat(backrs.colors['Colors/Base/Black']),
        width: '80px',
        height: '80px',
    });
};
var abbreviatedNameStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        color: backrs.colors['Gray/900'],
    });
};
var contentSx = {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
};
var headerContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        height: "calc(120px + ".concat(backrs.spacing['spacing-8xl'], ")"),
    });
};
var profileImageAndNameContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: backrs.spacing['spacing-2xl'],
    });
};
var profileImageWrapperStyle = {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
};
var smallProfileInfoContainerStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        paddingTop: backrs.spacing['spacing-md'],
        flex: 1,
        gap: backrs.spacing['spacing-xxs'],
        height: '100%',
    });
};
var smallProfileInfoChipContainerStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        paddingBottom: backrs.spacing['spacing-none'],
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'space-between',
    });
};
var chipContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        alignSelf: 'flex-start',
        justifySelf: 'flex-end',
        ml: backrs.spacing['spacing-none'],
    });
};
var infoRowStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        alignItems: 'flex-start',
        gap: backrs.spacing['spacing-sm'],
    });
};
var iconContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        marginTop: backrs.spacing['spacing-none'],
    });
};
var profileAttributeTextSx = function (maxLines, isItalic) {
    if (isItalic === void 0) { isItalic = false; }
    return ({
        alignSelf: 'flex-start',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        fontStyle: isItalic ? 'italic' : 'normal',
    });
};
